import en from "./en.json";
import hi from "./hi.json";
import ar from "./ar.json";
import fr from "./fr.json";

export const langObj = {
    en: en,
    hi: hi,
    ar: ar,
    fr: fr,
};
